import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppChoice from "@toothfairy/shared-ui/AppChoice";
import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppInputLabel from "@toothfairy/shared-ui/AppInputLabel";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppToast from "@toothfairy/shared-ui/AppToast";
import { useTranslation } from "react-i18next";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useEffect, useState } from "react";
import ToothFairyButton from "../../../Components/ToothFairyComponents/ToothFairyButton";
import ToothFairySwitch from "../../../Components/ToothFairyComponents/ToothFairySwitch";
import Constants from "../../../Constants";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import TopicsSelectionComponent from "../../MrcDocuments/Components/TopicsSelectionComponent";

const TrainingConfigSelection = ({
  selectedType,
  setSelectedType,
  trainingTypes,
  trainingConfig,
  setTrainingConfig,
  setIsTrainingInitiationModalOpen,
  handleTrainingInitiation,
  setSelectedTopics,
  selectedTopics,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const {
    getWorkspaceEntities,
    getPlanConfig,
    getFinetunedModels,
  } = useWorkspaces();
  const { state } = AppStateManager.useAppStateManager();
  const [finetunedModels, setFinetunedModels] = useState([]);

  const AppToasty = AppToast.useToast();
  const { t } = useTranslation();
  const topics = getWorkspaceEntities("topic")?.map((topic) => {
    topic.name = topic?.label;
    topic.category = topic.type;
    return topic;
  });
  useEffect(() => {
    if (state?.trainingLogs?.length > 0) {
      setFinetunedModels(getFinetunedModels());
    } else {
      setFinetunedModels([]);
    }
  }, [state?.trainingLogs]);
  return (
    <AppChoice
      wrapperStyle={{ alignSelf: "center", maxWidth: 600 }}
      caption={``}
      subCaption={t("training.modals.provideNameDescription")}
      cancelCaption={t("training.modals.cancelCaption")}
      confirmCaption={t("training.modals.confirmCaption")}
      onConfirmButtonPress={() => {
        if (!trainingConfig?.name || trainingConfig?.name == "") {
          {
            return AppToasty.show(t("TrainingCreationFailedCaptionName"), {
              placement: "bottom",
              type: "danger",
            });
          }
        }
        if (!trainingConfig?.baseModel || trainingConfig?.baseModel == "none") {
          return AppToasty.show(t("TrainingCreationFailedCaptionBaseModel"), {
            placement: "bottom",
            type: "danger",
          });
        }
        handleTrainingInitiation();
        // setIsTrainingInitiationModalOpen(false);
      }}
      onCancelButtonPress={() => {
        setIsTrainingInitiationModalOpen(false);
      }}
      AppChoiceButton={ToothFairyButton}
    >
      <AppInputLabel
        style={{ marginLeft: 0, marginBottom: 5, marginTop: 10 }}
        label={t("training.modals.selectType", { defaultValue: "Tuning type" })}
      />
      <AppDropDown
        dropDownStyle={{
          width: 470,
          borderColor: currentTheme?.theme?.border_color,
          marginBottom: 15,
        }}
        isElevated={false}
        dropdownIconColor="transparent"
        items={(trainingTypes || Constants.TRAINING_TYPES)?.map((tt) => ({
          id: tt.key,
          label: `${tt.short} — ${tt.title}`,
        }))}
        propertyLabel="label"
        propertyValue="id"
        selectedValue={selectedType}
        onValueChange={(itemValue) => setSelectedType(itemValue)}
      />

      <AppText
        color={currentTheme?.theme?.orange}
        leftIcon={AppAssets?.icons?.risk}
        style={{
          marginLeft: 10,
        }}
        wrapperStyle={{
          marginTop: 10,
          marginRight: 20,
        }}
      >
        {t("training.modals.minExamplesWarning")}
      </AppText>

      <AppTextInput
        placeholder={t("training.modals.namePlaceholder")}
        style={{
          marginTop: 2,
        }}
        wrapperInputStyle={{
          maxWidth: 470,
          marginBottom: 20,
          marginTop: 20,
        }}
        textContainer={{
          margin: 0,
        }}
        type="text"
        value={trainingConfig?.name}
        onChangeText={(text) => {
          setTrainingConfig({ ...trainingConfig, name: text });
        }}
      />
      <AppText
        style={{
          paddingLeft: 5,

          fontSize: currentTheme?.theme?.extra_small_font_size,
        }}
        wrapperStyle={{
          top: -10,
          justifyContent: "flex-start",
          marginRight: 20,
        }}
        iconSize={12}
        leftIcon={AppAssets?.icons?.question_icon}
      >
        {t("training.modals.nameHelpText")}
      </AppText>
      <AppTextInput
        multiline={true}
        numberOfLines={4}
        placeholder={t("training.modals.descriptionPlaceholder")}
        style={{
          marginTop: 2,
        }}
        wrapperInputStyle={{
          maxWidth: 470,
          marginBottom: 20,
        }}
        textContainer={{
          minHeight: 100,
          margin: 0,
          padding: 10,
          marginHorizontal: 0,
          paddingVertical: 10,
        }}
        type="text"
        value={trainingConfig?.description}
        onChangeText={(text) => {
          setTrainingConfig({ ...trainingConfig, description: text });
        }}
      />
      <>
        <TopicsSelectionComponent
          onSelectedTopicsChange={(v) => setSelectedTopics(v)}
          selectedTopics={selectedTopics}
          isTopicUpdateModeEnabled
          showAddNew={false}
          showEditIcon={false}
          topics={topics}
          placeholder={t("training.modals.filterTopicsPlaceholder")}
          wrapperStyle={{
            paddingTop: 0,
            paddingBottom: 20,
            marginRight: -2,
            maxWidth: 475,
          }}
          wrapperContainerStyle={{
            flex: 1,
            marginLeft: 0,
            margingRight: 0,
          }}
        />
        <AppDropDown
          dropDownStyle={{
            width: 470,

            borderColor: currentTheme?.theme?.border_color,
            marginRight: 10,
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={[
            {
              label: t("training.modals.selectBaseModel"),
              id: "none",
            },
            ...(state?.trainableModels || []),
            ...finetunedModels?.map((u) => {
              return {
                ...u,
                type: "conversational",
                label: u?.name,
                maxBatchSize: 8,
              };
            }),
          ]}
          propertyLabel="label"
          propertyValue="id"
          selectedValue={trainingConfig?.baseModel}
          onValueChange={(itemValue) => {
            setTrainingConfig({
              ...trainingConfig,
              baseModel: itemValue,
            });
          }}
        />
      </>

      <ToothFairySwitch
        wrapperStyle={{
          flex: 1,
          marginRight: 12,
          // backgroundColor: currentTheme?.theme?.inputBackgroundColor,
          marginTop: 20,
          zIndex: -1,
        }}
        disabled
        label={t("training.modals.datasetOnly")}
        onChange={(v) => {
          setTrainingConfig({
            ...trainingConfig,
            datasetOnly: v,
          });
        }}
        isTicked={true}
      />
    </AppChoice>
  );
};

export default TrainingConfigSelection;
